module.exports = __webpack_public_path__ + "img/69a7ab57164d2ad4.a89430a0.png";